export function checkDevice() {
  if (navigator.userAgent.match(/AppleWebKit.*Mobile.*/)) {
    // 判断是否是移动设备打开。browser代码在下面
    var ua = navigator.userAgent.toLowerCase(); // 获取判断用的对象
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      return 'wechat_browser';
    }
    return 'h5_browser';
  } else {
    return 'pc_browser';
  }
}

export function isFile(file) {
  if (!file) return false;
  if (file instanceof File) return true;
  if (file instanceof Blob) return true;
  if (file.size && file.lastModifiedDate && file.slice) return true;
}

/**
 * url拼接
 * 示例：
 *  urljoin('https://test.com','/demo','index.html') => 'https://abc.com/demo/index.html'
 *  urljoin('//test.com','assets','main.css') => '//test.com/assets/main.css'
 * @param  {...string} paths 带拼接的路径数组
 * @returns
 */
export function urljoin(...paths) {
  if (Array.isArray(paths) && paths.length) {
    return paths.reduce((url, currentValue, idx) => {
      if (typeof currentValue === 'string') {
        // 去除两边空格，并去除最后面的斜杠(/)
        currentValue = currentValue.trim().replace(/\/*$/gi, '');
        if (idx === 0) {
          url = currentValue;
        } else {
          // 去除最前面的斜杠(/)
          currentValue = currentValue.replace(/^\/*/gi, '');
          if (currentValue) {
            url = `${url}/${currentValue}`;
          }
        }
      }
      return url;
    }, '');
  }
  return '';
}
